import React from 'react';

import { useJobProspectsState, useJobProspectsActions } from './JobProspectsContext';
import { updateJobProspectStatus } from './restApi';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const ClosedJobModal = () => {
  const state = useJobProspectsState();
  const { closeConfirmClosedJobModal, onResponse, onError } = useJobProspectsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");
  
  const jobProspect = state?.confirmClosedJobForm;
  const isOpen = state?.confirmClosedJobModalIsOpen;
  const isJobProspectClosed = jobProspect?.status === 'closed';

  if (!jobProspect) return null;

  const handleConfirmClosed = () => {
    updateJobProspectStatus({
      onResponse,
      onError,
      body: {
        authenticityToken,
        selectedJobProspectStatus: 'closed',
        jobProspectId: jobProspect.id,
      },
    });
  };

  const handleVisitJob = () => {
    window.open(jobProspect.link, '_blank', 'noopener,noreferrer');
  };

  return (
    <StandardModal
      isOpen={isOpen}
      contentLabel={isJobProspectClosed ? "Job Prospect Closed" : "Job May Be Closed"}
      onRequestClose={closeConfirmClosedJobModal}
    >
      <Form>
        <FormInstruction>
          {isJobProspectClosed ? (
            <>
              <strong>You marked this job closed.</strong>
              <br />
              <br />
              You previously marked "{jobProspect.title}" at {jobProspect.biopharmaGroupName} as closed.
              <br />
              <br />
              You can still visit the job posting if you want to check if it's been reopened.
            </>
          ) : (
            <>
              <strong>This job may be closed.</strong>
              <br />
              <br />
              We detected that "{jobProspect.title}" at {jobProspect.biopharmaGroupName} might no longer be accepting applications.
              <br />
              <br />
              You can visit the job posting to verify, or mark this job prospect as closed if you confirm it's no longer available.
            </>
          )}
        </FormInstruction>

        <ResponsiveContainer name="form-actions">
          <FormActions>
            <Button
              variant="secondary"
              onClick={handleVisitJob}
            >
              Visit Job Posting
            </Button>
            <Button
              variant="secondary"
              onClick={closeConfirmClosedJobModal}
            >
              Cancel
            </Button>
            {!isJobProspectClosed && (
              <Button
                variant="primary"
                onClick={handleConfirmClosed}
              >
                Confirm Closed
              </Button>
            )}
          </FormActions>
        </ResponsiveContainer>
      </Form>
    </StandardModal>
  );
};

export default ClosedJobModal;